<template lang="pug">
AppDialog.holiday-dialog(
  size="smedium"
  position="centered"
  append-to-body
  :title="holiday.name"
  :show="show"
  @close="$emit('close')"
)
  .d-flex.align-items-center.justify-content-between
    .d-flex.align-items-center
      HubAvatar.avatar-overlaps(
        v-for="member in displayableMembers"
        :key="member.id"
        v-tooltip="{ delay: { hide: 0 } }"
        :title="member.name"
        :user-id="member.id"
        :users-avatars="usersAvatars"
        avatar-style="medium"
      )
      span.more-members-badge.light(v-if="showRemainingMembers") {{ remainingMembers }}

    .text-right All day
      .text-grey {{ holiday.date }}

  .table-condensed.table-borderless.table
    tr
      td Duration:
      td.strong.pl-5 {{ holiday.amountUsed }} hrs
</template>

<script>
import { createUsersAvatarsMixin } from '~/mixins/UsersAvatarsMixin';
import { AVATARS_MAX_DISPLAYABLE_MEMBERS } from '~/app_constants';

export default {
  name: 'HolidayDialog',
  mixins: [createUsersAvatarsMixin('assignedMembers')],
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    holiday() {
      return this.event.holidayAttributes;
    },
    assignedMembers() {
      return this.holiday.members;
    },
    displayableMembers() {
      return this.assignedMembers.slice(0, AVATARS_MAX_DISPLAYABLE_MEMBERS);
    },
    showRemainingMembers() {
      return this.assignedMembers.length > AVATARS_MAX_DISPLAYABLE_MEMBERS;
    },
    remainingMembers() {
      return `+${this.assignedMembers.length - AVATARS_MAX_DISPLAYABLE_MEMBERS}`;
    },
  },
};
</script>
